module.exports = __webpack_public_path__ + "static/media/spaghetti.e7a39633.svg";